import { langauge, SendgridMessageEventType } from 'shared';

import { Pill } from '../../../common/Atoms/Pill';

// Valid for both the Pill and Badge atoms
type EmailStatusColor = `green` | `gray` | `blue` | `indigo` | `amber` | `red`;

const statusColorMap: Record<string, EmailStatusColor> = {
  [SendgridMessageEventType.Delivered]: `green`,
  [SendgridMessageEventType.Processed]: `gray`,
  [SendgridMessageEventType.Open]: `blue`,
  [SendgridMessageEventType.Click]: `indigo`,
  [SendgridMessageEventType.Deferred]: `amber`,
  [SendgridMessageEventType.Dropped]: `red`,
  [SendgridMessageEventType.Bounce]: `red`,
  [SendgridMessageEventType.SpamReport]: `red`,
};

export function emailStatusLabel(status: string) {
  return (langauge.sendgrid.event as Record<string, string>)[status]
    || (status.charAt(0).toUpperCase() + status.slice(1));
}

export function emailStatusColor(status: string): EmailStatusColor {
  return statusColorMap[status] || `gray`;
}

export function EmailStatusPill({ status }: { status?: string | null }) {
  if (!status) return null;

  return (
    <Pill
      size={ `xs` }
      bordered
      color={ emailStatusColor(status) }
      message={ emailStatusLabel(status) }
      // Grid cells set a row-height line-height which would stretch the pill
      className={ `leading-normal` }
    />
  );
}
